
export class SecureConsortiumPage {

    constructor() {

        //document.ready
        $(() => {


        });
    }

}